import { useEffect, useCallback } from 'react';

interface ShortcutHandlers {
  onCommandK?: () => void;
  onEscape?: () => void;
}

export const useNavigationShortcuts = ({ onCommandK, onEscape }: ShortcutHandlers) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      // Command/Ctrl + K for search
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        onCommandK?.();
      }

      // Escape key
      if (event.key === 'Escape') {
        onEscape?.();
      }
    },
    [onCommandK, onEscape]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
};

